import { ByocMissionPopupService } from '../service/popup.service';
import { Directive, Input, HostListener } from '@angular/core';

@Directive({
    selector: '[appByocCreateMission]',
    standalone: false
})
export class ByocMissionDirective {
    @Input()
    byocMissionId?: string;

    @Input()
    isSubmodal?: any;

    constructor(private byocMissionPopupService: ByocMissionPopupService) {}

    /**
     * Open on host click
     */
    @HostListener('click', ['$event'])
    onClick($event: Event) {
        $event.preventDefault();
        this.byocMissionPopupService.open(<string>this.byocMissionId, this.isSubmodal);
    }
}
